import {
  Flex,
  Image,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import parse from "html-react-parser";
import options from "../../../support/parse-settings";

const BenefitModel = ({
  title,
  logo,
  content,
  isOpen,
  onClose,
  productColor,
}) => {
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent maxW="1000px">
          <ModalHeader bg={"blackAlpha.800"} color="white" fontSize="lg">
            <Flex
              alignItems={"center"}
              gap={8}
              color="white"
              sx={{
                img: {
                  maxW: "80%",
                  maxH: "60px",
                },
              }}
            >
              {logo && (
                <img
                  src={logo.url}
                  alt={title}
                  width={`${logo.width}px`}
                  height={`${logo.height}px`}
                />
              )}{" "}
              {title}
            </Flex>
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody p="6">{content && parse(content, options)}</ModalBody>
          <ModalFooter bg="blackAlpha.200">
            <Button
              color="white"
              bg={productColor}
              _hover={{
                bg: "black",
              }}
              mr={3}
              size="sm"
              onClick={onClose}
              variant="solid"
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default BenefitModel;
